export enum TaskType {
  BUDGET_CREATE = 'create_budget',
  BUDGET_UPDATE = 'update_budget',
}
